export default __webpack_public_path__ + "static/media/YoutubeSVG.89b89aa9.svg";